import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";

import { MobilePlatform } from "@state/stores/types";
import { HeaderSuggestedSearchList } from "./HeaderSuggestedSearchList";
import { isCapacitorPlatform } from "@utils/specific/capacitor";
import { top } from "safe-area-insets";
import { HEADER_HEIGHT } from "@utils/style/constants";

export default observer(function HeaderSuggestedSearchPopup() {
	const rootStore = useRootAppStore<MobilePlatform>();
	const searchStore = rootStore.searchStore;

	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		function handleClickOutside(event: MouseEvent | TouchEvent) {
			if (
				containerRef.current &&
				!containerRef.current.contains(event.target as Node)
			) {
				searchStore.setIsSuggestedListOpen(false);
			}
		}

		if (searchStore.isSuggestedListOpen) {
			document.addEventListener("touchstart", handleClickOutside);
		}

		return () => {
			document.removeEventListener("touchstart", handleClickOutside);
		};
	}, [searchStore.isSuggestedListOpen]);

	const popupPadding = isCapacitorPlatform()
		? { top: top + HEADER_HEIGHT }
		: {};

	return ReactDOM.createPortal(
		<div ref={containerRef} className="popup--search" style={popupPadding}>
			<div className="popup--search__body">
				<HeaderSuggestedSearchList searchStore={searchStore} />
			</div>
		</div>,
		document.body
	);
});
